import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PlantService } from 'src/app/services/plant.service';

@Component({
  standalone: false,
  selector: 'app-remove-modal',
  templateUrl: './remove-modal.component.html',
  styleUrls: ['./remove-modal.component.scss'],
})
export class RemoveModalComponent implements OnInit {
  @Input() id: string;

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private plantService: PlantService
  ) {
    this.myForm = this.formBuilder.group({
      DeleteRemarks: ['', [Validators.maxLength(500), Validators.required]],
      deletedBy: '',
      vegetationId: ''
    });
  }

  ngOnInit(): void {}

  onSubmit(): void {
    if (this.myForm.valid) {
      this.myForm.patchValue({ deletedBy: localStorage.getItem('claAdminId'), vegetationId: this.id } as any);
      console.log(this.myForm.value);
      this.plantService
      .removePlantVegitation(this.myForm.value)
      .subscribe((res) => {
        console.log(res);
        this.router.navigate(['/listplants']);
      });
      this.modal.dismiss();
    } else {
      this.myForm.markAllAsTouched();
    }
  }
}
